module.exports = __webpack_public_path__ + "prod/1.2.3/img/qywx.4cfc4f15.png";